import React from 'react'
import {HiArrowLongRight} from 'react-icons/hi2'
import './styles/cta.css'

const CTA = () => {
  return (
    <div className='container cta-container'>
        <h2 className='cta-heading' 
        
        >Become Our Partner</h2>
        <p className='cta-para'>Join a growing network of innovative app developers and publishers who are transforming user engagement into real revenue.</p>
        <button
        onClick={() => {
          window.open("https://publisher.realopinions.ai/register")
        }}
        className='btn-primary cta-btn'>Become Our Partner <HiArrowLongRight></HiArrowLongRight></button>
    </div>
  )
}

export default CTA;